module.exports = __webpack_public_path__ + "img/HZ-T1505.90ff9b38.jpg";